import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/utils/api";
import { useTranslation } from "react-i18next";

type Props = {
  handlePopupType: (type: string) => void;
};

const VerifyAccount = ({ handlePopupType }: Props) => {
   const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error" | "expired">("loading");


  // In VerifyAccount component
useEffect(() => {
  if (status === "success") {
    const timer = setTimeout(() => {
      handlePopupType("close"); // Or whatever closes the popup
    }, 1000); // 1 second delay
    return () => clearTimeout(timer);
  }
}, [status, handlePopupType]);

useEffect(() => {
  let isMounted = true;
  let ignoreResponse = false;  // New flag to ignore responses after unmount
  
  const verify = async () => {
    const code = searchParams.get("code");
    const email = searchParams.get("email");

    if (!code || !email) {
      if (isMounted && !ignoreResponse) setStatus("expired");
      return;
    }

    try {
      const result = await api.verifyEmail({ code, email });
      if (isMounted && !ignoreResponse) {
        if (result.status === "success" && result.data?.success) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      }
    } catch (err) {
      if (isMounted && !ignoreResponse) setStatus("error");
    }
  };

  verify();

  return () => {
    isMounted = false;
    ignoreResponse = true;  // Set this to true when unmounting
  };
}, [searchParams]);

  return (
    <div className="text-center p-4 text-white">
      {status === "loading" && (
        <div className="d-flex justify-content-center my-4">
          <div className="spinner-border" role="status" style={{ width: 40, height: 40 }}></div>
        </div>
      )}

      {status === "success" && (
        <>
          <div className="mb-3">
            <i className="fas fa-check-circle" style={{ fontSize: "60px", color: "#3cd278" }}></i>
          </div>
          <h4 className="mb-2">{t('SVerification')}</h4>
          <p>{t("SVerified")}</p>
        </>
      )}

      {status === "error" ? (
        <>
          <div className="mb-3">
            <i className="fas fa-times-circle" style={{ fontSize: "60px", color: "#CF3127" }}></i>
          </div>
          <h4 className="mb-2 text-white">{t("EVerification")}</h4>
          <p className="text-white">{t("EVerified")}</p>
        </>
      ) : null}
    </div>
  );
};

export default VerifyAccount;
